import { useLocation } from 'react-router-dom';
import { CalendarOff, Info } from 'lucide-react';
import { useClosures } from '@/hooks/useClosures';

const SHOWN_PATHS = ['/', '/produits', '/panier', '/checkout'];

/** Note client des fermetures & congés (Admin › Zones & Pétales › Fermetures) — accueil, marché, panier, paiement. */
export default function ClosureNotice() {
  const { pathname } = useLocation();
  const { notices } = useClosures();
  if (!SHOWN_PATHS.includes(pathname) || !notices?.length) return null;
  return (
    <div className="w-full" data-testid="closure-notices">
      {notices.map(n => {
        const ongoing = n.status === 'ongoing';
        const full = n.kind === 'full';
        const tone = ongoing && full ? 'bg-brick/10 border-brick text-stone-text' : ongoing ? 'bg-waffle/25 border-waffle text-stone-text' : 'bg-paper border-clay text-stone-text';
        const Icon = ongoing ? CalendarOff : Info;
        const period = n.start === n.end ? `le ${n.start_label}` : `du ${n.start_label} au ${n.end_label}`;
        return (
          <div key={n.id} className={`border-b border-l-4 ${tone}`} data-testid={`closure-notice-${n.id}`}>
            <div className="max-w-7xl mx-auto px-4 md:px-12 py-2.5 flex items-start gap-3 font-sans text-sm">
              <Icon className={`h-4 w-4 mt-0.5 shrink-0 ${ongoing && full ? 'text-brick' : 'text-forest'}`} />
              <p className="leading-snug">
                <strong data-testid={`closure-notice-title-${n.id}`}>
                  {full ? (ongoing ? 'Commandes fermées' : 'Fermeture à venir') : (ongoing ? 'Pas de livraison' : 'Pas de livraison')} {period}
                  {n.label ? ` — ${n.label}` : ''}
                </strong>
                {n.note && <span className="block text-[13px] opacity-90" data-testid={`closure-notice-note-${n.id}`}>{n.note}</span>}
                {!full && <span className="block text-xs opacity-70">Vous pouvez commander pour les livraisons suivantes.</span>}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
